/* eslint-disable import/order */
import AuthService, { Bootstrap, User } from '@hotmart/cas-js'

import appPackage from 'src/../package.json'
import { AuthProvider, Subscribe } from '../types'
import { hasValidReferer, isLogoutRoute } from './utils'

const AUTH_SERVICE_CONFIG = {
  env: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  // eslint-disable-next-line camelcase
  client_id: process.env.AUTH_CLIENT_ID,
  scope: 'openid profile email authorities'
}

class CasProviderService implements AuthProvider {
  private bootstrap: Bootstrap = {} as Bootstrap

  constructor() {
    const authService = new AuthService(AUTH_SERVICE_CONFIG)

    /**
     * If the current route is a logout route, it triggers a silent login.
     * To enforce a logout, simply call the signinRedirect method.
     * This will initiate the redirection process for logging the user out.
     */
    if (isLogoutRoute()) {
      authService.signinRedirect()
      return
    }

    const signinRedirect = hasValidReferer()

    this.bootstrap = new Bootstrap(authService, {
      appName: appPackage.name,
      signinRedirect,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    })
  }

  async getUser(): Promise<User> {
    return this.bootstrap.getUser()
  }

  start() {
    this.bootstrap.start()
  }

  stop() {
    this.bootstrap.stop()
  }

  subscribe({ next, error }: Subscribe) {
    this.bootstrap.subscribe({
      next,
      error
    })
  }

  async logout() {
    try {
      await this.bootstrap.logout()
    } catch {
      console.error('error to logout')
    }
  }
}

export default CasProviderService
